// jsPDF's addImage only recognizes PNG/JPEG/GIF/WEBP/BMP/TIFF, not the .ico
// format the company favicon is stored in (browsers decode ICO fine in an
// <img> tag, jsPDF does not), so it needs to be redrawn onto a canvas and
// re-exported as PNG before it can be embedded in a generated PDF.
export function convertImageToPngDataUrl(url: string): Promise<string | null> {
  return new Promise(resolve => {
    const img = new Image()
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas')
        canvas.width = img.naturalWidth || img.width
        canvas.height = img.naturalHeight || img.height
        const ctx = canvas.getContext('2d')
        if (!ctx) {
          resolve(null)
          return
        }
        ctx.drawImage(img, 0, 0)
        resolve(canvas.toDataURL('image/png'))
      } catch {
        resolve(null)
      }
    }
    img.onerror = () => resolve(null)
    img.src = url
  })
}
